import React, { Component } from 'react'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'
import Head from 'next/head'
import getCanonicalUrl from '../../lib/getCanonicalUrl'
import Layout from '../../components/Layout'
import Text from '../../components/Text/Text'
import Router, { withRouter } from 'next/router'
import Filter from '../../components/Filter/Filter'
import Sort from '../../components/Sort/Sort'
import { get, headers } from '../../lib/fetch'
import { getActiveExperimentVariants } from '../../lib/getActiveExperimentVariants'
import {
  mapFiltersFromUrl,
  modifyFormat,
  generateQueryString,
  convertFilters,
  removeNullValues,
} from '../../lib/filterFormatter'
import {
  BREAKPOINT_CHECKS,
  findOptionAndDeviceFromQuery,
  SCREEN_SIZE,
} from '../../lib/Media'
import MainWrp from '../../containers/Main/Main'
import { cookieValuetoJSON } from '../../lib/objectValidation'
import ProductCollection from '../../components/ProductCollection'
import { PAGE_TYPES, GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'
import InfantFormulaPopup, {
  INFANT_FORMULA_CATEGORY,
} from '../../components/InfantFormulaPopup/InfantFormulaPopup'
import { getIosSmartBannerContent } from '../../utils/getIosSmartBannerContent'
import { getUserType } from '../../utils/userType'
import {
  AMP_EVENT_NAME,
  CTA_LOCATION_NAME,
  getPageTypeByUrl,
} from '../../lib/amplitude'
import { setCtaLocationMeta } from '../../lib/utils'
import { EventTrackingConsumer } from '../../components/EventTrackingProvider/EventTrackingProvider'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import _get from 'lodash/get'
import SwimlaneCountdown from '../../components/SwimlaneCountdown/SwimlaneCountdown'
import { getAllFilterCount } from '../../utils/Utils'
import Toast from '@ntuctech/devex-tangram/Toast'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import {
  getDyFBTExperiments,
  initDyCookies,
  initDyParams,
  setDySession,
} from '../../utils/DyUtils'

const Heading = styled.h1`
  margin-bottom: 1rem;
  text-transform: capitalize;
`

const FilterAndSortContainer = styled.div`
  display: flex;
  margin: 1.125rem 0rem;
  ${SCREEN_SIZE.Only.Tablet} {
    margin: 0 0 1.125rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    flex-direction: column;
    margin: 0rem;
    > div:not(:last-child) {
      margin-bottom: 0.5rem;
    }
  }
`

const PlainDiv = styled.div`
  width: 100%; /* IE 11 */
  ${SCREEN_SIZE.From.Desktop} {
    width: ${props =>
      props.withFilterAndSort ? 'calc(100% - 15.5rem)' : '100%'};
    padding-left: 1.5rem;
  }
  display: block;
`

const PlainDivForMobileAndTablet = styled.div`
  display: block;
  ${SCREEN_SIZE.From.Desktop} {
    display: none;
  }
`

const PlainDivForDesktopAndHd = styled.div`
  display: none;
  ${SCREEN_SIZE.From.Desktop} {
    display: flex;
  }
`

const Title = styled(Heading)`
  padding-top: 0;
  ${SCREEN_SIZE.From.Desktop} {
    padding-top: 0.5rem;
  }
`

const getData = async (checkoutAddress, router, userkey) => {
  const query = router.query
  const activeExperiments = getActiveExperimentVariants()
  const fbtExperiments = getDyFBTExperiments(true)
  let experiments = fbtExperiments
    ? `${activeExperiments},${fbtExperiments}`
    : activeExperiments

  if (query.customListing === 'emptySearchR4u') {
    experiments = experiments.replace('rec-r4u-dy', 'rec-r4u-ds')
  }

  const queryStringObject = {
    orderType: getUserType(router) === 'B2B' ? 'B2B' : 'DELIVERY',
    experiments: experiments,
    source: 'SEEALL',
  }
  const searchOverrideParams = ['pageType', 'url']

  // Added Algopers params
  const { configuration } = getConfigFor(SPLIT_FEATURES.ALGOLIA_PERSONALISATION)
  const { personalisationSettings } = configuration
  queryStringObject.algopers = personalisationSettings

  for (let key in query) {
    if (key === 'customListing') {
      continue
    }
    if (key !== 'filter' && !searchOverrideParams.includes(key)) {
      queryStringObject[key] = encodeURIComponent(query[key])
    }
    const apiType = queryStringObject?.personalisationApi

    if (apiType && apiType === 'past-purchase') {
      key = 'past-purchase'
    }

    // setting this for search override
    if (
      ['tag', 'category', 'brand', 'past-purchase', 'offerlist'].includes(key)
    ) {
      queryStringObject.pageType = key
      queryStringObject.url = query[key]
    }
  }

  searchOverrideParams.forEach(searchOverrideParam => {
    if (
      !queryStringObject[searchOverrideParam] &&
      !!query[searchOverrideParam]
    ) {
      queryStringObject[searchOverrideParam] = query[searchOverrideParam]
    }
  })

  // DY
  const dyParams = initDyParams(router)

  const productApi = 'product/v2'

  if (query.filter) {
    const transferredFilter = mapFiltersFromUrl(query.filter)
    queryStringObject.filter = convertFilters(transferredFilter)
  }

  if (checkoutAddress && checkoutAddress.storeId) {
    const storeId = checkoutAddress.storeId
    queryStringObject.storeId = storeId
  }
  let request = productApi + generateQueryString(queryStringObject) + dyParams
  const modifiedHeaders = {
    ...headers(router),
    'x-device-Id': userkey,
  }
  if (typeof window === 'undefined') {
    modifiedHeaders['user-agent'] = router?.req?.headers['user-agent']
  }
  request +=
    request.indexOf('?') > -1
      ? '&includeTagDetails=true'
      : '?includeTagDetails=true'
  const response = await get(request, {
    headers: modifiedHeaders,
  })

  return response
}
class ProductListingWrapper extends Component {
  constructor(props) {
    super(props)
    const { optionKey, deviceKey } = findOptionAndDeviceFromQuery(
      SCREEN_SIZE.From.Desktop
    )
    let isDesktop = false
    if (typeof window !== 'undefined') {
      isDesktop = BREAKPOINT_CHECKS[optionKey][deviceKey](window.innerWidth)
    }
    const { query } = this.props.router

    this.state = {
      filters: [],
      appliedFilters: mapFiltersFromUrl(query.filter),
      sortType: query.sorting,
      isDesktop,
    }
    this.handleApplyFilter = this.handleApplyFilter.bind(this)
    this.handleSortType = this.handleSortType.bind(this)
    this.changeRoute = this.changeRoute.bind(this)
  }

  componentDidMount() {
    setDySession(this.props?.metaData)
    setCtaLocationMeta([(this.props.router?.query?.title || '').toLowerCase()])

    // if query params has amendOrder then show toast
    if (this.props.router?.query?.amendOrder) {
      this.setState({
        ...this.state,
        amendOrder: true,
      })
    }
    initDyCookies()
  }

  handleSortType(sortType, sortLabel) {
    this.setState({ sortType }, () => {
      this.changeRoute(this.state.appliedFilters, sortType)
    })
    const query = this.props.router?.query || {}
    this.props.track({
      [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.SORT_BY_SELECTED,
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: CTA_LOCATION_NAME.PRODUCT_LISTING,
        pageMeta: [query?.pageType],
      },
      [GEV.AMPLITUDE_SORT_BY_CATEGORY]: sortLabel?.toLowerCase(),
    })
  }

  handleApplyFilter(filters, selectedFilter) {
    this.setState({ appliedFilters: filters }, () => {
      this.changeRoute(filters, this.state.sortType)
    })
    // only track if filter is applied
    if (!selectedFilter?.checked) {
      const query = this.props.router?.query || {}
      this.props.track({
        [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.FILTER_SELECTED,
        [GEV.AMPLITUDE_CTA_LOCATION]: {
          pageName: CTA_LOCATION_NAME.PRODUCT_LISTING,
          pageMeta: [query?.pageType],
        },
        [GEV.AMPLITUDE_FILTER_CATEGORY]:
          selectedFilter?.category?.toLowerCase(),
        [GEV.AMPLITUDE_FILTER_DETAILS]: selectedFilter?.label?.toLowerCase(),
      })
    }
  }

  changeRoute(filters, sortType) {
    let href = this.props.router.pathname
    let asPath = this.props.router?.asPath?.split('?')[0]
    // keep the query parameters other than sort and filter as it is in case of clear filter
    // eslint-disable-next-line no-unused-vars
    const { filter, sorting, ...rest } = this.props.router.query
    const queryStringObject = { ...rest }
    if (filters && Object.keys(filters).length) {
      queryStringObject.filter = convertFilters(filters)
    }
    if (queryStringObject.title) {
      queryStringObject.title = encodeURIComponent(queryStringObject.title)
    }
    if (queryStringObject.subtitle) {
      queryStringObject.subtitle = encodeURIComponent(
        queryStringObject.subtitle
      )
    }
    if (sortType) {
      queryStringObject.sorting = sortType
    }
    asPath += generateQueryString(queryStringObject)
    queryStringObject.slug = this.props.router.query.slug
    href += generateQueryString(queryStringObject)
    Router.push(href, asPath)
  }

  async componentDidUpdate(prevProps) {
    const { checkoutAddress, router } = this.props
    if (
      (prevProps.checkoutAddress &&
        String(prevProps.checkoutAddress.storeId) !==
          String(checkoutAddress.storeId)) ||
      prevProps.checkoutAddress.type !== checkoutAddress.type
    ) {
      const response = await getData(
        checkoutAddress,
        router,
        this.props.userkey
      )
      setDySession(response?.data?.metaData)
      this.setState({
        storeSpecificProduct: { data: response.data },
        isStoreChanged: true,
      })
    }

    // check for query changes to use changed data from props instead of state
    if (
      (prevProps.router.query.slug !== this.props.router.query.slug ||
        prevProps.router.query.filter !== this.props.router.query.filter ||
        prevProps.router.query.sorting !== this.props.router.query.sorting) &&
      this.state.isStoreChanged
    ) {
      this.setState({
        isStoreChanged: false,
      })
    }

    const isStoreChanged = this.state && this.state.isStoreChanged
    const data = isStoreChanged
      ? this.state.storeSpecificProduct
      : this.props.data
    // Added this to bypass the problem with `useClientRouting` not
    // setting `loading` to `true` when `getInitialProps` is called.

    const productLayout = data && data.data && data.data.product
    if (!productLayout) {
      return
    }

    if (this.state.productCollection !== productLayout) {
      this.setState({
        productCollection: productLayout,
      })
    }
  }

  render() {
    const { isDesktop } = this.state
    const {
      organizationData,
      router,
      categoryList,
      iosSmartBannerContent,
      isOOS,
    } = this.props
    const isStoreChanged = this.state && this.state.isStoreChanged
    const data = isStoreChanged
      ? this.state.storeSpecificProduct
      : this.props.data
    const name = (router.query && router.query.title) || ''
    const productLayout = (data && data.data && data.data.product) || []

    // set page type based on query params
    // send it to child components for tracking & deciding API exp variant
    const query = router?.query || {}
    let currentPageType = query?.pageType || PAGE_TYPES.PRODUCT_LISTING
    if (
      query?.personalisationApi &&
      query.pageType === query.personalisationApi
    ) {
      currentPageType = query.personalisationApi
    } else {
      for (const key in query) {
        if (['tag', 'category', 'brand'].includes(key)) {
          currentPageType = PAGE_TYPES[key.toUpperCase()]
        }
      }
    }
    const isEnabledApiExperiment = true
    let { filters } = (data && data.data) || {}

    if (isEnabledApiExperiment && filters?.side) {
      filters = filters.side
    }
    if (filters && !isEnabledApiExperiment && !filters.side) {
      filters = modifyFormat(filters)
    } else if (filters && isEnabledApiExperiment) {
      filters = removeNullValues(filters)
    }
    const { count: productCount } = (data && data.data) || 0
    const isProductListingPage =
      getPageTypeByUrl(this.props.pathname) ===
      CTA_LOCATION_NAME.PRODUCT_LISTING
    const formattedName = name ? name.replace(',', '').replace(/\s/g, '') : ''

    const loc = isOOS
      ? 'ProductListing-OOSFindSimilar'
      : isProductListingPage && formattedName
      ? `ProductListing-${formattedName}`
      : 'ProductListing'
    return (
      <NdsThemeProvider>
        <React.Fragment>
          <Head>
            <title>{name} | FairPrice Singapore</title>
            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content={`${name} | FairPrice Singapore`}
            />
            <link rel="canonical" href={getCanonicalUrl(router.asPath)} />
            <meta property="og:site_name" content="FairPrice" />
            <meta name="apple-itunes-app" content={iosSmartBannerContent} />
          </Head>
          {this.state.amendOrder && (
            <Toast
              type="success"
              message="Start adding items to your upcoming delivery"
            />
          )}
          {!isDesktop && (
            <PlainDivForMobileAndTablet>
              <SwimlaneCountdown swimlaneTitle={name} rounded={false} />
            </PlainDivForMobileAndTablet>
          )}
          <Layout
            organizationData={organizationData}
            noWrapper="fromDesktop"
            categoryList={categoryList}
          >
            {!isDesktop && (
              <PlainDivForMobileAndTablet>
                {name && productCount > 0 && (
                  <Title>
                    <Text size="xl" weight="bold">
                      {name && name.toLowerCase()}
                    </Text>
                    <div>
                      <Text size="medium" weight="bold" color="#696969">
                        {`${productCount} ${
                          productCount > 1 ? 'products' : 'product'
                        }`}
                      </Text>
                    </div>
                  </Title>
                )}
                {!isEmpty(filters) && (
                  <FilterAndSortContainer>
                    <Filter
                      filterCount={getAllFilterCount(this.state.appliedFilters)}
                      data={filters}
                      onApplyFilters={this.handleApplyFilter}
                      except={['PWP', 'isEndlessAisle']}
                      isEnabledApiExperiment={isEnabledApiExperiment}
                    />
                    <Sort onHandleSort={this.handleSortType} />
                  </FilterAndSortContainer>
                )}
                <PlainDiv withFilterAndSort={!isEmpty(filters)}>
                  <ProductCollection
                    data={{
                      collection: {
                        product: productLayout,
                        count: productCount,
                      },
                    }}
                    title={name}
                    ctaLocation={{
                      pageName: CTA_LOCATION_NAME.PRODUCT_LISTING,
                      pageMeta: [query?.pageType],
                    }}
                    config={{
                      layoutType: 'GRID',
                      pageType: currentPageType,
                      loadMoreType: 'INFINITE',
                      loc: loc,
                      ctaLocation: {
                        pageName: CTA_LOCATION_NAME.PRODUCT_LISTING,
                        pageMeta: [query?.pageType],
                      },
                      metaData: this.props?.data?.data?.metaData || {},
                    }}
                    withFilterAndSort={!isEmpty(filters)}
                    source="SEEALL"
                  />
                </PlainDiv>
              </PlainDivForMobileAndTablet>
            )}
            {isDesktop && (
              <PlainDivForDesktopAndHd>
                {!isEmpty(filters) && (
                  <FilterAndSortContainer>
                    <Sort onHandleSort={this.handleSortType} />
                    <Filter
                      filterCount={getAllFilterCount(this.state.appliedFilters)}
                      data={filters}
                      onApplyFilters={this.handleApplyFilter}
                      except={['PWP', 'isEndlessAisle']}
                      isEnabledApiExperiment={isEnabledApiExperiment}
                    />
                  </FilterAndSortContainer>
                )}
                <PlainDiv withFilterAndSort={!isEmpty(filters)}>
                  <MainWrp>
                    {name && productCount > 0 && (
                      <Heading>
                        <Text size="xl" weight="bold">
                          {name && name.toLowerCase()}
                        </Text>
                        <div>
                          <Text size="medium" weight="bold" color="#696969">
                            {`${productCount} ${
                              productCount > 1 ? 'products' : 'product'
                            }`}
                          </Text>
                        </div>
                      </Heading>
                    )}
                    <SwimlaneCountdown swimlaneTitle={name} />
                    <ProductCollection
                      data={{
                        collection: {
                          product: productLayout,
                          count: productCount,
                        },
                      }}
                      title={name}
                      ctaLocation={{
                        pageName: CTA_LOCATION_NAME.PRODUCT_LISTING,
                        pageMeta: [query?.pageType],
                      }}
                      config={{
                        layoutType: 'GRID',
                        pageType: currentPageType,
                        loadMoreType: 'INFINITE',
                        loc: loc,
                        metaData: this.props?.data?.data?.metaData || {},
                      }}
                      withFilterAndSort={!isEmpty(filters)}
                      preLoadFirstImage={true}
                      source="SEEALL"
                    />
                  </MainWrp>
                </PlainDiv>
              </PlainDivForDesktopAndHd>
            )}
            {Object.values(INFANT_FORMULA_CATEGORY).includes(
              this.props.data?.data?.page?.entity?.slug
            ) && (
              <InfantFormulaPopup
                categorySeen={this.props.data?.data?.page?.entity?.slug}
              />
            )}
          </Layout>
        </React.Fragment>
      </NdsThemeProvider>
    )
  }
}

const ProductListing = props => (
  <EventTrackingConsumer>
    {({ track }) => <ProductListingWrapper {...props} track={track} />}
  </EventTrackingConsumer>
)

ProductListing.getInitialProps = async ctx => {
  const userkey = ctx.res
    ? _get(ctx, 'res.locals.userKey')
    : window.__NEXT_DATA__?.props?.userKey
  const iosSmartBannerContent = getIosSmartBannerContent(ctx)
  const user_type = getUserType(ctx)
  const isOOS = ctx.query?.oos
  const checkoutAddress = cookieValuetoJSON(
    ctx,
    user_type === 'B2B' ? 'b2bCheckoutAddress' : 'checkoutAddress'
  )
  const response = await getData(checkoutAddress, ctx, userkey)
  return {
    data: { data: response.data },
    iosSmartBannerContent,
    isOOS,
    pathname: ctx.pathname,
    userkey,
    metaData: response.data?.metaData,
  }
}

export default withRouter(ProductListing)
